import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Plus } from "lucide-react";

interface ActionButtonConfig {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  className?: string;
}

interface PageHeaderProps {
  title: string;
  description?: string;
  showCreateButton?: boolean;
  createButtonLabel?: string;
  onCreateClick?: () => void;
  className?: string;
  actions?: React.ReactNode;
  actionButtons?: ActionButtonConfig[];
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  showCreateButton = false,
  createButtonLabel = "Create",
  onCreateClick,
  className,
  actions,
  actionButtons = [],
}) => {
  return (
    <div className={cn("flex justify-between items-center mb-6", className)}>
      <div>
        <h2 className="text-2xl font-bold text-primary">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        )}
      </div>
      <div className="flex items-center gap-2">
        {actions}
        
        {/* Render custom action buttons */}
        {actionButtons.map((button, index) => (
          <Button 
            key={`action-btn-${index}`}
            onClick={button.onClick}
            variant={button.variant || "default"}
            className={button.className || ""}
          >
            {button.icon && (
              <span className="mr-2">{button.icon}</span>
            )}
            {button.label}
          </Button>
        ))}
        
        {/* Default create button */}
        {showCreateButton && (
          <Button onClick={onCreateClick} className="bg-primary hover:bg-primary/80 text-primary-foreground">
            <Plus className="mr-2 h-4 w-4" />
            {createButtonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;